import React, { FunctionComponent, useState } from 'react';
import { map } from 'ramda';
import { IBindingCallback1 } from '../../../../common/models/callback';
import { IQuestionForReference } from '../../../../common/models/question/IQuestionForReference';
import { getDefaultIntl, getDefaultMessage } from '../Question/utils';
import RegularButton from '../../../../components/RegularButton';
import TextArea from '../../../../components/TextArea';
import Icon from '../../../../components/Icon';
import { formatQuestionText } from '../../containers/QuestionsContainer/utils';
import styles from './styles.module.scss';

interface IVerificationQuestionProps {
  isPreview: boolean;
  question: IQuestionForReference;
  candidateName: string;
  onAnswer: IBindingCallback1<IQuestionForReference>;
}

const VerificationQuestion: FunctionComponent<IVerificationQuestionProps> = ({
  isPreview,
  question,
  candidateName,
  onAnswer
}) => {
  const [currentQuestion, setCurrentQuestion] = useState(question);

  const [extraAnswer, setExtraAnswer] = useState(question.extraReferenceQuestion.answer);

  const onSubmit = (answer: string) => {
    const extraQuestion = currentQuestion.extraReferenceQuestion;
    onAnswer({
      ...question,
      answer,
      extraReferenceQuestion: {
        ...extraQuestion,
        answer: answer === question.option ? extraAnswer : undefined
      }
    });
  };

  const onAnswerQuestion = (answer: string) => {
    setCurrentQuestion({ ...question, answer });
    if (answer !== question.option) {
      onSubmit(answer);
    }
  };

  const getButtons = () => (
    map(o => (
      <RegularButton
        size="lg"
        key={o}
        variant={currentQuestion.answer === o ? 'primary' : 'secondary'}
        textIntlId={getDefaultIntl(o)}
        defaultMessage={getDefaultMessage(o)}
        onClick={() => onAnswerQuestion(o)}
      />
    ), question.options)
  );

  return (
    <div className="d-flex flex-column justify-content-center survey-question-block">
      <p className="survey-page-title">{formatQuestionText(question.text, candidateName)}</p>
      <div className={styles.buttonBlock}>
        {getButtons()}
      </div>
      <div className={`${styles.textAreaBlock} mt-4`}>
        {(question.option && question.option === currentQuestion.answer)
          ? (
            <div>
              <TextArea
                onChange={setExtraAnswer}
                input={extraAnswer}
                placeholder={question.extraReferenceQuestion.text}
              />
              <div className="survey-buttons">
                <RegularButton
                  size="lg"
                  textIntlId="survey.next"
                  defaultMessage="Next"
                  onClick={() => onSubmit(currentQuestion.answer as string)}
                  iconPosition="right"
                  icon={<Icon icon="arrowRight" />}
                  disabled={!currentQuestion.answer && !isPreview}
                />
              </div>
            </div>
          )
          : null}
      </div>
    </div>
  );
};

export default VerificationQuestion;
